
export class CountyTaxRate {
    county: string;
    surtax: number;
    effective_date: Date;
    expiration_date: Date;
}

function CountyTaxRate_tsickle_Closure_declarations() {
/** @type {?} */
CountyTaxRate.prototype.county;
/** @type {?} */
CountyTaxRate.prototype.surtax;
/** @type {?} */
CountyTaxRate.prototype.effective_date;
/** @type {?} */
CountyTaxRate.prototype.expiration_date;
}
